import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { TabsetComponent } from "ngx-bootstrap/tabs";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { Subscription } from "rxjs/Subscription";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { SpeCodeListComponent } from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import {
  ExplorerService,
  ModalConfig,
  TransferState,
} from "@app/modules/shared/services/explorer.service";
import { FilterItem } from "@app/modules/shared/model/detail-filter.interface";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { findIndex, get, isEmpty } from "lodash";
import { isArray } from "util";
import * as wjCore from "wijmo/wijmo";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-bulk-material-import",
  templateUrl: "./bulk-material-import.component.html",
  styleUrls: ["./bulk-material-import.component.scss"],
})
export class BulkMaterialImportComponent implements OnInit, OnDestroy {
  @ViewChild("staticTabs", { static: true }) staticTabs: TabsetComponent;
  @Input() tabId: string;
  @Input() templateContext: any;
  filterTabSelect = true;
  materialTabSelect = false;
  alertShow = false;
  alertMessage = "";
  materialList = [];
  materialCollectionView: wjCore.CollectionView;
  locale =
    PrimengLocal[
      localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];
  tunnel: Subscription;
  selectedFilterValues: Array<FilterItem> = [];
  materialCodeExpressionValue: any;
  materialDescriptionExpressionValue: any;
  materialBrandExpressionValue: any;
  materialRayonExpressionValue: any;
  materialSpecodeExpressionValue1: any;
  materialSpecodeExpressionValue2: any;
  materialSpecodeExpressionValue3: any;
  materialSpecodeExpressionValue4: any;
  totalDataLength = 0;
  selectedDataLength = 0;

  allChecked = true;
  get = get;

  private _materialStatusValue: any;
  set materialStatusValue(value: any) {
    this._materialStatusValue = value;
    if (value) {
      const payload = {
        label: "material_status",
        key: "materialStatusValue",
        value: value,
        accessor: "status",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_status" },
        payload
      );
    } else {
      this._materialStatusValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_status",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialStatusValue() {
    return this._materialStatusValue;
  }

  private _materialTypeValue: any;
  set materialTypeValue(value: any) {
    if (value) {
      if (value.length > 0) {
        this._materialTypeValue = value;
        const payload = {
          label: "material_type",
          key: "materialTypeValue",
          value: value,
          accessor: "type",
        };
        this.insertOrUpdate(
          this.selectedFilterValues,
          { label: "material_type" },
          payload
        );
      } else {
        const index = findIndex(this.selectedFilterValues, {
          label: "material_type",
        });
        if (index >= 0) {
          this.selectedFilterValues.splice(index, 1);
          this._materialTypeValue = null;
        }
      }
    } else {
      this._materialTypeValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_type",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialTypeValue() {
    return this._materialTypeValue;
  }

  private _materialCodeValue: any;
  set materialCodeValue(value: any) {
    if (value) {
      this._materialCodeValue = value;
      const payload = {
        label: "material_code",
        key: "materialCodeValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_code" },
        payload
      );
    } else {
      const index = findIndex(this.selectedFilterValues, {
        label: "material_code",
      });
      this._materialCodeValue = null;
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialCodeValue() {
    return this._materialCodeValue;
  }

  private _materialDescriptionValue: any;
  set materialDescriptionValue(value: any) {
    if (value) {
      this._materialDescriptionValue = value;
      const payload = {
        label: "material_description",
        key: "materialDescriptionValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_description" },
        payload
      );
    } else {
      this._materialDescriptionValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_description",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialDescriptionValue() {
    return this._materialDescriptionValue;
  }

  private _materialSpeCodeValue1: any;
  set materialSpeCodeValue1(value: any) {
    if (value) {
      this._materialSpeCodeValue1 = value;
      const payload = {
        label: "material_specode",
        key: "materialSpeCodeValue1",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode" },
        payload
      );
    } else {
      this._materialSpeCodeValue1 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue1() {
    return this._materialSpeCodeValue1;
  }

  private _materialSpeCodeValue2: any;
  set materialSpeCodeValue2(value: any) {
    if (value) {
      this._materialSpeCodeValue2 = value;
      const payload = {
        label: "material_specode2",
        key: "materialSpeCodeValue2",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode2" },
        payload
      );
    } else {
      this._materialSpeCodeValue2 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode2",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue2() {
    return this._materialSpeCodeValue2;
  }

  private _materialSpeCodeValue3: any;
  set materialSpeCodeValue3(value: any) {
    if (value) {
      this._materialSpeCodeValue3 = value;
      const payload = {
        label: "material_specode3",
        key: "materialSpeCodeValue3",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode3" },
        payload
      );
    } else {
      this._materialSpeCodeValue3 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode3",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue3() {
    return this._materialSpeCodeValue3;
  }

  private _materialSpeCodeValue4: any;
  set materialSpeCodeValue4(value: any) {
    if (value) {
      this._materialSpeCodeValue4 = value;
      const payload = {
        label: "material_specode4",
        key: "materialSpeCodeValue4",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode4" },
        payload
      );
    } else {
      this._materialSpeCodeValue4 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode4",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue4() {
    return this._materialSpeCodeValue4;
  }

  dateFormatString: string;
  MaterialSpecodeListComponent = SpeCodeListComponent;
  materialStatusOptions = [
    {
      label: this.translateService.instant("ALL"),
      value: null,
    },
    {
      label: this.translateService.instant("ACTIVE"),
      value: {
        status: "ACTIVE",
      },
    },
    {
      label: this.translateService.instant("PASSIVE"),
      value: {
        status: "PASSIVE",
      },
    },
  ];
  materialTypeOptions = [
    {
      label: this.translateService.instant("COMMERCIAL_GOODS"),
      value: {
        type: "COMMERCIAL_GOODS",
      },
    },
    {
      label: this.translateService.instant("PRODUCT"),
      value: {
        type: "PRODUCT",
      },
    },
    {
      label: this.translateService.instant("SEMI_PRODUCT"),
      value: {
        type: "SEMI_PRODUCT",
      },
    },
    {
      label: this.translateService.instant("RAW_MATERIAL"),
      value: {
        type: "RAW_MATERIAL",
      },
    },
    {
      label: this.translateService.instant("FUEL"),
      value: {
        type: "FUEL",
      },
    },
  ];
  materialExpressionOptions = [
    {
      label: this.translateService.instant("LIKE"),
      value: "LIKE",
    },
    {
      label: this.translateService.instant("NOT_LIKE"),
      value: "NOT_LIKE",
    },
    {
      label: this.translateService.instant("EQ"),
      value: "EQ",
    },
    {
      label: this.translateService.instant("NOT_EQ"),
      value: "NOT_EQ",
    },
    {
      label: this.translateService.instant("START_WITH"),
      value: "START_WITH",
    },
    {
      label: this.translateService.instant("END_WITH"),
      value: "END_WITH",
    },
    {
      label: this.translateService.instant("GT"),
      value: "GT",
    },
    {
      label: this.translateService.instant("GE"),
      value: "GE",
    },
    {
      label: this.translateService.instant("LT"),
      value: "LT",
    },
    {
      label: this.translateService.instant("LE"),
      value: "LE",
    },
  ];

  constructor(
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private klAlertService: KlAlertService,
    private dateConvert: ConvertIsoDateService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private apiService: ApiService
  ) {
    this.dateFormatString = UtilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.tunnel = this.explorerService.transferState$.subscribe((state) => {
      switch (state.state) {
        case "MATERIAL_DETAIL_FILTER_SPECODE1_CURRENT_ITEM":
          this.materialSpeCodeValue1 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE2_CURRENT_ITEM":
          this.materialSpeCodeValue2 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE3_CURRENT_ITEM":
          this.materialSpeCodeValue3 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE4_CURRENT_ITEM":
          this.materialSpeCodeValue4 = state.payload.code;
          this.cd.markForCheck();
          break;
      }
    });
  }

  ngOnInit() {
    this.materialList = [];
    this.materialCollectionView = new wjCore.CollectionView(this.materialList);
    this.materialCodeExpressionValue = "LIKE";
    this.materialDescriptionExpressionValue = "LIKE";
    this.materialBrandExpressionValue = "LIKE";
    this.materialRayonExpressionValue = "LIKE";
    this.materialSpecodeExpressionValue1 = "LIKE";
    this.materialSpecodeExpressionValue2 = "LIKE";
    this.materialSpecodeExpressionValue3 = "LIKE";
    this.materialSpecodeExpressionValue4 = "LIKE";
  }

  changeAllCheck(event) {
    if (event) {
      this.selectedDataLength = this.totalDataLength;
    } else {
      this.selectedDataLength = 0;
    }
    this.materialCollectionView.sourceCollection.forEach((line) => {
      return (line.selected = this.allChecked);
    });
    this.materialCollectionView.refresh();
  }

  changeCheckBox(event, cell) {
    console.log("cell : ", cell);
    if (event) {
      this.selectedDataLength = this.selectedDataLength + 1;
    } else {
      this.selectedDataLength = this.selectedDataLength - 1;
    }
  }

  materialListTabSelected() {
    this.filterTabSelect = false;
    this.materialTabSelect = true;
    this.materialCollectionView.refresh();
  }

  filterTabSelected() {
    this.filterTabSelect = true;
    this.materialTabSelect = false;
  }

  importSelectedMaterials() {
    const payload = [];
    this.materialCollectionView.sourceCollection.forEach((line) => {
      if (line.selected) {
        payload.push(line);
      }
    });
    const state = <TransferState>{
      state: "BULK_MATERIAL_TRANSFER" + this.tabId,
      payload: payload,
    };
    this.explorerService.transferState(state);
    this.closeModal();
  }

  commitFilter() {
    this.klLoadingService.show("loading");
    const preparedFilter: any = this.prepareFilterObject();
    if (isEmpty(preparedFilter["filter"]["modified_dates"])) {
      delete preparedFilter["filter"]["modified_dates"];
    }
    if (isEmpty(preparedFilter["filter"]["created_dates"])) {
      delete preparedFilter["filter"]["created_dates"];
    }
    this.apiService
      .getSpecialFilteredData("material/retail-material-info", preparedFilter)
      .finally(() => {
        this.klLoadingService.hide();
        this.cd.markForCheck();
      })
      .subscribe(
        (response) => {
          if (response.data) {
            this.materialList = [];
            this.totalDataLength = response.data.length;
            this.selectedDataLength = response.data.length;
            response.data.forEach((material) => {
              Object.assign(material, { selected: true });
              this.materialList.push(material);
            });
            this.staticTabs.tabs[1].disabled = false;
            this.staticTabs.tabs[1].active = true;
          }
          this.materialCollectionView = new wjCore.CollectionView(
            this.materialList
          );
        },
        (error) => this.handleError(error)
      );
  }

  setModal(title: string, stateSelector: string, template: any) {
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: "MATERIAL_DETAIL_FILTER_" + stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        dblSelect: true,
        template: template,
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  closeModal() {
    this.explorerService.closeModal(this);
  }

  deleteFromValues(index, item) {
    this.selectedFilterValues.splice(index, 1);
    this[item.key] = null;
  }

  insertOrUpdate(array: any[], meta: any, value: any) {
    const index = findIndex(array, meta);
    if (index >= 0) {
      array.splice(index, 1);
      array.push(value);
      return;
    }
    return array.push(value);
  }

  prepareFilterObject() {
    const filterObject = Object.create(null);
    filterObject["modified_dates"] = Object.create(null);
    filterObject["created_dates"] = Object.create(null);
    const parametersObject = [];
    if (this.materialStatusValue) {
      filterObject["status"] = this.materialStatusValue.status;
    }
    if (this.materialTypeValue) {
      filterObject["types"] = this.materialTypeValue.map((o) => {
        return o.type;
      });
    }
    if (this.materialCodeValue) {
      if (this.materialCodeExpressionValue === "IN") {
        if (this.materialCodeValue.includes(";")) {
          this.materialCodeValue = this.materialCodeValue.replace(" ", "");
          filterObject["code"] = this.materialCodeValue.split(";");
        } else {
          filterObject["code"] = [this.materialCodeValue];
        }
      } else {
        filterObject["code"] = this.materialCodeValue;
      }
      parametersObject.push({
        name: "code",
        expression: { operator: this.materialCodeExpressionValue },
      });
    }
    if (this.materialDescriptionValue) {
      filterObject["description"] = this.materialDescriptionValue;
      parametersObject.push({
        name: "description",
        expression: { operator: this.materialDescriptionExpressionValue },
      });
    }
    if (this.materialSpeCodeValue1) {
      filterObject["special_code"] = this.materialSpeCodeValue1;
      parametersObject.push({
        name: "special_code",
        expression: { operator: this.materialSpecodeExpressionValue1 },
      });
    }
    if (this.materialSpeCodeValue2) {
      filterObject["special_code2"] = this.materialSpeCodeValue2;
      parametersObject.push({
        name: "special_code2",
        expression: { operator: this.materialSpecodeExpressionValue2 },
      });
    }
    if (this.materialSpeCodeValue3) {
      filterObject["special_code3"] = this.materialSpeCodeValue3;
      parametersObject.push({
        name: "special_code3",
        expression: { operator: this.materialSpecodeExpressionValue3 },
      });
    }
    if (this.materialSpeCodeValue4) {
      filterObject["special_code4"] = this.materialSpeCodeValue4;
      parametersObject.push({
        name: "special_code4",
        expression: { operator: this.materialSpecodeExpressionValue4 },
      });
    }
    const query = {
      paging: {
        limit: 2000,
        offset: 0,
        fetch: "EAGER",
      },
    };
    Object.assign(filterObject, this.templateContext.filter);
    const filter = Object.assign(
      {},
      { filter: filterObject },
      { parameters: parametersObject },
      { query: query }
    );
    return filter;
  }

  isArray(value) {
    return !!Array.isArray(value);
  }

  isDate(value) {
    return value instanceof Date;
  }

  convertDate(value) {
    return this.dateConvert.convertDateAndTime(value);
  }

  getTranslated(item, accessor?) {
    let string = "";
    if (isArray(item)) {
      item.forEach((i) => {
        string += this.translateService.instant(get(i, accessor)) + ", ";
      });
      return string;
    } else if (item instanceof Date) {
      return this.dateConvert.convertDate(item);
    } else {
      if (accessor) {
        string += this.translateService.instant(get(item, accessor));
        return string;
      } else {
        string += this.translateService.instant(item);
        return string;
      }
    }
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.alertShow = true;
    this.alertMessage = this.utilService.alertErrorMessage(error);
  }

  ngOnDestroy() {
    this.tunnel.unsubscribe();
  }
}
